import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommandService } from '@core/services/command.service';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import { Observable, Subject } from 'rxjs';
import { TaskManagerApiService } from '../../services/task-manager-api.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'particle-status-settings-dialog',
  templateUrl: './status-settings-dialog.component.html',
  styleUrls: ['./status-settings-dialog.component.scss']
})
export class StatusSettingsDialogComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  unSubscribe$ = new Subject<void>();
  constructor( protected commandService: CommandService,protected taskManagerApiService: TaskManagerApiService) { }
  statusSettings: any;
  numbers: Number[];
  isSettingUpdate:boolean;
  updatedSetting:any;
  ngOnInit() {
    this.isSettingUpdate = false;
    this.numbers = [];
    this.statusSettings = {};
    this.statusSettings.dueNowInDays = 1;
    this.statusSettings.upcomingInDays = 1;
    this.statusSettings.futureInDays = 1;
    this.statusSettings.boardId = this.data.input.scopeInt;
    for(var i = 1;i<=60;i++){
      this.numbers.push(i);
    }

     this.taskManagerApiService.getStatusSettings(this.data.input.boardId,this.data.input.scopeInt).pipe(takeUntil(this.unSubscribe$)).subscribe(x=>{
       this.statusSettings  = x;
    });;

  }

  onOkClicked(): boolean {

      this.data.input.statusSettings = this.statusSettings;
      this.data.input.isSettingUpdate = this.isSettingUpdate;
      return true;

  }
  updateStatusSettings(settings){
    this.isSettingUpdate = true;
    //this.statusSettings = settings;
  }
  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

}
